import {
  getQueryInterval,
  timeframeToRange
} from "src/organization/pages/project/environment/metrics/components/Chart/settings";
import { TimeFrameType } from "src/organization/pages/project/environment/metrics/resources/types";

import getMetrics from "./getMetrics";

type GetMetricsProps = {
  url: string;
  query: any;
  timeFrame: TimeFrameType;
};

const getMetrics2 = async <T = any>({
  url,
  query,
  timeFrame
}: GetMetricsProps) => {
  const { from, to } = timeframeToRange(timeFrame);

  return await getMetrics<T>(url, {
    interval: getQueryInterval(timeFrame),
    range: { from, to },
    ...query
  });
};

export default getMetrics2;
